import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { ButtonBase, InputBase } from "../../../common/components/form";
import * as API from "../../lib/api";
import * as Links from "../../lib/links";
import { setAccount, setShowUnauthorized } from "../../store/panel";
import AutorizationTopBar from "../Authorization/AutorizationTopBar.jsx";

export default function Login() {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const history = useHistory();

    const [mainError, setMainError] = React.useState(null);
    const [processing, setProcessing] = React.useState(false);
    const [complete, setComplete] = React.useState(false);
    const [fields, setFields] = React.useState({
        email: "",
        password: "",
    });
    const [errors, setErrors] = React.useState({});

    React.useEffect(() => {
        dispatch(setShowUnauthorized(false));
        scroll({ top: 0, behavior: "smooth" });
    }, []);

    function onChange(event) {
        let { name, value } = event.target;
        setFields({ ...fields, [name]: value });

        const _errors = { ...errors };

        switch (name) {
            case "email":
                _errors[name] = null;
                value = value.toLowerCase();

                if (!value || !value.trim().length) {
                    _errors[name] = "ErrorFieldEMailEnter";
                }

                break;

            case "password":
                _errors[name] = null;

                if (!value) {
                    _errors[name] = "ErrorFieldPasswordEnter";
                }

                break;
        }

        setFields({ ...fields, [name]: value });
        setErrors(_errors);
    }

    function onBackClick() {
        // window.open(window.location.origin, "_self");
        location = "/";
    }

    function onRegisterClick(event) {
        event.preventDefault();
        history.push(Links.Register());
    }

    function onForgotPasswordClick() {
        history.push("/login/restoring-access");
    }

    function onLoginClick() {
        setProcessing(true);

        accountAuth()
            .then(account => {
                setComplete(!!account);

                account &&
                    setTimeout(() => {
                        dispatch(setAccount(account));
                        history.push(Links.Dashboard());
                    }, 1000);
            })
            .finally(() => setProcessing(false));

        function accountAuth() {
            setMainError(null);

            return API.Send("/account/auth", {
                email: fields.email,
                password: fields.password,
            }).then(res => {
                if (!res?.ok) {
                    if (res.ok === false) {
                        setMainError("LoginWrongEmailOrPassword");
                    } else {
                        setMainError("UnknownError");
                    }

                    return null;
                }

                delete res.ok;

                return res;
            });
        }
    }

    function onSubmit(event) {
        event.preventDefault();
    }

    function errorByField(fieldname) {
        return errors[fieldname] ? t(errors[fieldname]) : null;
    }

    const allowNext =
        Object.values(errors).filter(v => v).length === 0 &&
        (() => {
            for (const [key, value] of Object.entries(fields)) {
                if (key === "promocode") {
                    continue;
                }

                if (!value) {
                    return false;
                }
            }

            return true;
        })();

    const CNPanelLogin = ["panel-login"];
    processing && CNPanelLogin.push("processing");
    complete && CNPanelLogin.push("complete");

    return (
        <>
            <div className="auth-bg-blur" />

            <div className={CNPanelLogin.join(" ")}>
                <AutorizationTopBar />

                <form action="#" onSubmit={onSubmit}>
                    <div className="panel-login-fields">
                        <h1>{t("Welcome")}</h1>

                        <div className="margin-top-20">
                            <div>
                                <InputBase
                                    name="email"
                                    onChange={onChange}
                                    value={fields.email || ""}
                                    placeholder={t("Email")}
                                    error={errorByField("email") || ""}
                                    style={{ minWidth: "264px" }}
                                    fullWidth
                                    small
                                />
                            </div>

                            <div>
                                <InputBase
                                    name="password"
                                    type="password"
                                    onChange={onChange}
                                    value={fields.password || ""}
                                    placeholder={t("Password")}
                                    error={errorByField("password") || ""}
                                    style={{ minWidth: "264px" }}
                                    fullWidth
                                    small
                                />
                            </div>
                        </div>

                        {mainError && (
                            <p className="field-message color-error">{mainError ? t(mainError) : <>&nbsp;</>}</p>
                        )}

                        <div className="panel-login-buttons">
                            <ButtonBase solid onClick={onBackClick}>
                                {t("Back")}
                            </ButtonBase>

                            <ButtonBase invert type="submit" onClick={onLoginClick} disabled={!allowNext}>
                                {t("Login")}
                            </ButtonBase>
                        </div>
                    </div>

                    <div className="margin-top-40">
                        <p>
                            {t("DontHaveAccount")}
                            <a
                                className="link"
                                href="/register"
                                onClick={onRegisterClick}
                                style={{ color: "dodgerblue" }}
                            >
                                <b>{t("Register")}</b>
                            </a>
                        </p>
                    </div>

                    <p className="margin-top-20">
                        <ButtonBase link onClick={onForgotPasswordClick}>
                            {t("ForgotYourPassword")}
                        </ButtonBase>
                    </p>
                </form>
            </div>
        </>
    );
}
